import { render, staticRenderFns } from "./CurrentReadingBooks.vue?vue&type=template&id=764df3cc&"
import script from "./CurrentReadingBooks.vue?vue&type=script&lang=js&"
export * from "./CurrentReadingBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports